
import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as Fa from "react-icons/fa";
// import { format } from "date-fns";
import storage from "../../Services/Storage";
import { createAPIEndpointSGRExcel, Endpoint } from "./SGRService";
import { Calendar } from "primereact/calendar";


const SGRBrandEligibility = () => {
    const auth = storage.getLocal("user");
    const [selectedQuarter, setSelectedQuarter] = useState();
    const [quarters, setQuarters] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [maxQuarterDate, setMaxQuarterDate] = useState("");
    const [minQuarterDate, setMinQuarterDate] = useState("");
    const [tableData, setTableData] = useState();

    const getquarterApi = () => {
        createAPIEndpointSGRExcel()
            .get(`${Endpoint.GetQtrData}`)
            .then((response) => {
                // console.log("data000", response.data.Data);
                setQuarters(response.data.Data);
                setSelectedQuarter(response.data.Data[0]);
                handlechangeDateQuarter(response.data.Data[0]);
            })
            .catch(() => {

            });
    };
    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);
        return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
            .toString()
            .padStart(2, "0")}/${d.getFullYear()}`;
    };

    const getTableData = () => {
        const formattedFromDate = formatDate(fromDate);
        const formattedToDate = formatDate(toDate);
        createAPIEndpointSGRExcel()
            .get(`${Endpoint.GetTableData}?CompId=${auth.CompId}&strFromDate=${formattedFromDate}&strToDate=${formattedToDate}&Quater=${selectedQuarter.QTR_ID.toString().slice(4,5)}`)
            .then((response) => {
                // console.log("table", response.data);
                setTableData(response.data);
            })
            .catch(() => {

            });
    };


    const getQuarterDates = (quarter, year) => {
        let startDate, endDate;
        const today = new Date();
        switch (quarter) {
        case 1:
            startDate = new Date(year, 0, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 2, 31);
            break;
        case 2:
            startDate = new Date(year, 3, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 5, 30);
            break;
        case 3:
            startDate = new Date(year, 6, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 8, 30);
            break;
        case 4:
            startDate = new Date(year, 9, 1);
            startDate.setSeconds(startDate.getSeconds() + 2);
            endDate = new Date(year, 11, 31);
            break;
        default:
            return null;
        }
    
        if (new Date(endDate).getTime() > new Date(today).getTime()) {
            endDate = new Date(today);
        }
    
        return { fromDate: startDate, toDate: endDate };
    };

    const handlechangeDateQuarter = (value) => {
        // console.log("value", value);
        let value1 = value.QTR_DESC;
        setSelectedQuarter(value);
        let splitdata = value1.split(" ");
        let getquarter = splitdata[1].replace(",", "");
        let getyear = splitdata[2];
        let getquaterdata = getQuarterDates(parseInt(getquarter), getyear);
        setFromDate(getquaterdata.fromDate);
        setToDate(getquaterdata.toDate);
        setMinQuarterDate(getquaterdata.fromDate);
        setMaxQuarterDate(getquaterdata.toDate);
    };

    const QuarterTemplate = (quarter) => {
        // console.log("quarter", quarter);
        return <>{quarter.QTR_DESC}</>;
    };


    useEffect(() => {
        getquarterApi();
    }, []);

    return (
        <>
            <div className="col-12 pt-3 pb-3">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">SGR Brand Eligibility</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button type="button" title="Download Eligibility" className="btn btn-primary"
                            >Download Eligibility  <Fa.FaDownload className='ms-2' />
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row">
                            <form>
                                <div className="row">
                                    <div className="col-lg-3 col-md-3 col-sm-12 mb-3">
                                        <label className="form-label">Quarter</label>
                                        <Dropdown
                                            inputId="queter"
                                            name="queter"
                                            value={selectedQuarter}
                                            onChange={(e) => handlechangeDateQuarter(e.value)}
                                            options={quarters}
                                            optionLabel="QTR_DESC"
                                            itemTemplate={QuarterTemplate}
                                        // disabled={todayDisable}
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-12 mb-3">
                                        <label className="form-label">From  Date</label>
                                        <Calendar
                                            showIcon
                                            value={fromDate}
                                            minDate={minQuarterDate}
                                            maxDate={maxQuarterDate}
                                            showMinMaxRange={true}
                                            dateFormat="dd/mm/yy"
                                            onChange={(e) => setFromDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-12 mb-3">
                                        <label className="form-label">To  Date</label>

                                        <Calendar
                                            value={toDate}
                                            showIcon
                                            showMinMaxRange={true}
                                            dateFormat="dd/mm/yy"
                                            //   maxDate={maxQuarterDate}
                                            minDate={minQuarterDate}
                                            onChange={(e) => setToDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-lg-2 col-md-2 col-sm-12 mb-3 pt-1"></div>
                                    <div className="col-lg-1 col-md-1 col-sm-12 mb-3 pt-1">
                                        <div className="float-end mb-2 mt-4">
                                            <button type="button" title="View" className="btn btn-primary me-2"
                                                onClick={getTableData} >View
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </form>
                </section>
                <section className="mt-3">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3>Foc Unlock Request Details</h3>
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="DataTable">
                                <DataTable
                                    value={tableData}
                                    // tableStyle={{ minWidth: "60rem" }}
                                    rows={10}
                                    filterDisplay="row"
                                    showGridlines
                                    stripedRows
                                    selectionMode="checkbox"
                                    scrollHeight="80vh"
                                    scrollable
                                // selection={selectedCustomer}
                                // onSelectionChange={(e) => {
                                //     setSelectedCustomer(e.value);
                                // }}
                                >
                                    {/* <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column> */}
                                    <Column field="COMPANY_NAME" header="COMPANY"  ></Column>
                                    <Column field="SGR_REF" header="SGR" ></Column>
                                    <Column field="TOTAL" header="% SD" ></Column>
                                    <Column field="MARKET_VAL" header="MARKET(%)" ></Column>
                                    <Column field="BASE_DISC" header="BASE DISC.(%)" ></Column>
                                    <Column field="ODT_MANUAL" header="ODT(%)" ></Column>
                                    <Column field="FINAL_VAL" header="FINAL(%)" ></Column>
                                    <Column field="" header="View Details" ></Column>

                                </DataTable>
                            </div>
                        </div>
                    </div>
                </section>


            </div>
        </>
    );
};

export default SGRBrandEligibility;